/**
    商品列表
**/
<template>
     <div class="header_logo">
        <el-menu
             background-color="#ff6700"
             mode="horizontal"
             router
             class="el-menu-vertical-demo">
                 <el-menu-item><img class="xunyouText" :src="logo" @click="$router.push('/')" alt=""></el-menu-item>
                 <el-menu-item v-for="item in leftMenu" :key="item.id" :index="item.url">
                     <template slot="title"><i :class="item.icon"></i>{{item.menu}}</template>                        
                 </el-menu-item>            
         </el-menu>
         <div class="middle">
             <router-view></router-view>
         </div>
    </div>
</template>
<script>
import { setImage } from "@/api/xunyou";
export default {
  data() {
    return {
        leftMenu:[
            {
                id:1,
                menu:'商城首页',
                url:'/',
                icon:'el-icon-s-home'
            },
            {
                id:2,
                menu:'用户中心',
                url:'/userCenter',
                icon:'el-icon-user'
            }, 
            {
                id:3,
                menu:'支付中心',
                url:'/paymentCenter',
                icon:'el-icon-coin'
            },
        ],
        logo:''
    };
  },
  // 注册组件
  components: {},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {
      this.getImagelogo()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
      // 获取logo
    getImagelogo() {
      setImage().then((res) => {
        if (res.code == 0) {
          this.logo = res.rows[0].pcLogo;
          console.log(res.rows[0].pcLogo);
        }
      });
    }
  },
};
</script>

<style scoped lang="less">
.header_logo{
    height: 100%;
    .xunyouText{
        width: 100px;
        max-height: 60px;
    }
    li.el-menu-item {
        color: white !important;
        font-size: 16px;
        i{
            color: white;
            vertical-align: inherit;
        }
    }
    .middle{
        height: 100% !important;
        // background: url("~@/assets/img/userCenterbg.jpg") no-repeat;
        background-repeat: no-repeat;
        background-size: cover;
        // background: #fff;
    }

}
.breakcrumbHeader {
  margin: 15px 0;
}
// .leftaside.el-col.el-col-6 {
//     background: white;
//     padding: 30px;
//     box-sizing: border-box;
//     .el-menu{
//         border-right:0px;
//         li.el-menu-item-group {
//             margin-bottom: 15px;
//         }
//     }
//     /deep/ .el-menu-item-group__title {
//             padding: 7px 0 10px 20px;
//             line-height: normal;
//             font-size: 14px;
//             color: #333;
//         }
//     li.el-menu-item {
//         height: 24px;
//         line-height: 24px;
//         font-size: 12px;        
//     }
//     .el-menu-item:focus, .el-menu-item:hover {
//         outline: 0;
//         background-color: transparent;
//     }
//     .el-menu-item.is-active {
//         color: #ff6700;
//     }
// }


</style>

 
 

 


// WEBPACK FOOTER //
// src/views/siteNavigation/siteNavigation.vue